import customAxios from "./axios";
import CONFIG from "../../config";

export const getAll = () => {
  return customAxios.get(CONFIG.apiURL + "/MasterProcesses").then((res) => {
    let response = res["data"];
    return response;
  });
};

export const getIndividual = (id) => {
  return customAxios
    .get(CONFIG.apiURL + `/MasterProcesses/${id}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const create = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/MasterProcesses/Create", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const update = (payload) => {
  return customAxios
    .put(CONFIG.apiURL + "/MasterProcesses/Update", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getProcess = (payload) => {
  return customAxios
    .get(CONFIG.apiURL + "/MasterProcesses/Process", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};
